import { useCandidateAuthStore } from "./candidateAuthStore";

/**
 * Hook personnalisé pour gérer la déconnexion des applications candidates.
 *
 * Supprime le store d'authentification du localStorage et recharge la page.
 * La modale de login réapparaîtra automatiquement car lastName sera vide.
 *
 * @example
 * ```tsx
 * const { logout } = useCandidateLogout();
 *
 * <Navbar onLogout={logout} />
 * ```
 */
export function useCandidateLogout() {
  const clear = useCandidateAuthStore((state) => state.clear);

  const logout = () => {
    // 1. Supprimer le store du localStorage (clé "candidate-auth")
    clear();

    // 2. Recharger la page courante
    // La modale de login réapparaîtra automatiquement car lastName sera vide
    window.location.reload();
  };

  return { logout };
}
